import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { device } from "../../services/styles";
import { fetchApi } from "../../services/requests";
import Link from "next/link";

const Container = styled.div`
  box-shadow: 0px 10px 20px #0000001f;
  margin: 40px 0;
  border-radius: 20px;
  padding: 20px 20px 20px 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media print {
    display: none;
  }
`;

const ContentContainer = styled.div`
  width: calc(100% - 90px);
  @media ${device.tablet} {
    width: calc(100% - 120px);
  }
`;

const ImageContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 40px;
  margin-right: 10px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${device.tablet} {
    width: 100px;
    height: 100px;
    border-radius: 50px;
    margin-right: 20px;
  }
`;

const AuthorImage = styled.img`
  align-self: center;
  width: 100%;
`;

const Header = styled.p`
  font-size: 18px;
  line-height: 24px;
  font-weight: 900;
  margin: 0;
`;
const LightText = styled.p`
  font-size: 14px;
  line-height: 18px;
  color: #9b9b9b;
  margin: 0 0 10px 0;
`;
const BoldText = styled.p`
  font-size: 14px;
  line-height: 14px;
  font-weight: 900;
  margin: 10px 0 18px 0;
`;

const Text = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin: 20px 0;
`;
const AuthorLink = styled.a`
  display: block;
  width: 100%;
  color: #4762ab;
  font-size: 14px;
  line-height: 1;
  margin-top: 20px;
  text-align: center;
`;

const Author = ({ author }) => {
  const [lawFirm, setLawFirm] = useState(null);
  useEffect(() => {
    const getLatFirm = async () => {
      const [data] = await fetchApi({
        url: `agrarlex-lawfirm/${author.law_firms[0]}`,
      });
      if (data) {
        setLawFirm(data);
      }
    };
    if (author.law_firms && author.law_firms.length) {
      getLatFirm();
    }
  }, []);
  return (
    <Container>
      <ImageContainer>
        <AuthorImage src={author.image} alt={`autor ${author.name}`} />
      </ImageContainer>
      <ContentContainer>
        <Header>{author.name}</Header>
        {lawFirm && <LightText>{lawFirm.name}</LightText>}

        <BoldText>{author.specialization}</BoldText>
        <Text>{author.description}</Text>
      </ContentContainer>
      <Link
        href={`/artykuly/redaktorzy/[journalist]`}
        as={`/artykuly/redaktorzy/${author.pk}`}
        passHref={true}
      >
        <AuthorLink>przeczytaj inne artykuły tego autora</AuthorLink>
      </Link>
    </Container>
  );
};

export default Author;
